<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="35"
    viewBox="0 0 40 34.64101615137754"
    style="filter: drop-shadow(rgba(0, 0, 0, 0.75) 0px 0px 3px);"
  >
    <path
      fill="#424242"
      d="M0 17.32050807568877L10 0L30 0L40 17.32050807568877L30 34.64101615137754L10 34.64101615137754Z"
    ></path>
  </svg>
</template>

<script>
export default {
  props: ["color"]
};
</script>

<style scoped>
svg {
  position: absolute;
  top: -11px;
  left: 1px;
}
</style>
